import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE, } from "../../tools/webservice";
import adminWorkLogs from "apis/inspectorAdminWorkLogs";

export const getInspectorAdminTimeLog = (inspectorNumber, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: adminWorkLogs.getAdminTimeLog(inspectorNumber, payPeriodId),
  successCallback,
  mountedRef,
});
export const addInspectorAdminTimeLog = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: adminWorkLogs.addEditDeleteAdminTimeLog(),
  payload,
  successCallback,
  mountedRef,
});
export const editInspectorAdminTimeLog = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: adminWorkLogs.addEditDeleteAdminTimeLog(),
  payload,
  successCallback,
  mountedRef,
});
export const deleteInspectorAdminTimeLog = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: adminWorkLogs.addEditDeleteAdminTimeLog(),
  payload,
  successCallback,
  mountedRef,
});
export const getInspectorAdminWorkTypes = (inspectorNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: adminWorkLogs.getAdminWorkTypes(inspectorNumber),
  successCallback,
  mountedRef,
});